import { useAccount, useSignTypedData } from 'wagmi';
import dayjs from 'dayjs';
import { SignTypedDataVariables } from '@wagmi/core/query';
import { useWithdrawal } from '@/lib/services/aiEarn/signature.service';
type SignWithdrawData = {
  amount: string;
};
export function useSignWithdraw() {
  const { signTypedDataAsync } = useSignTypedData();
  const { address } = useAccount();
  const { mutate: withdraw, isPending: isWithdrawing } = useWithdrawal();
  const signAndSendWithdrawData = async ({ amount }: SignWithdrawData) => {
    if (!address) {
      throw new Error('address is required');
    }
    const timestamp = dayjs().unix() * 1000;

    const data = {
      domain: {
        name: 'HyperliquidSignTransaction',
        version: '1',
        chainId: 42161,
        verifyingContract: '0x0000000000000000000000000000000000000000',
      },
      message: {
        destination: address,
        amount: amount,
        time: timestamp,
        type: 'withdraw3',

        signatureChainId: '0xa4b1',
        hyperliquidChain: 'Mainnet',
      },
      primaryType: 'HyperliquidTransaction:Withdraw' as const,
      types: {
        EIP712Domain: [
          { name: 'name', type: 'string' },
          { name: 'version', type: 'string' },
          { name: 'chainId', type: 'uint256' },
          { name: 'verifyingContract', type: 'address' },
        ],
        'HyperliquidTransaction:Withdraw': [
          { name: 'hyperliquidChain', type: 'string' },
          { name: 'destination', type: 'string' },
          { name: 'amount', type: 'string' },
          { name: 'time', type: 'uint64' },
        ],
      },
    };
    const signature = await signTypedDataAsync(data as SignTypedDataVariables);
    withdraw({
      nonce: timestamp,
      address,
      amount,
      signature,
    });
  };
  return {
    signAndSendWithdrawData,
    isWithdrawing,
  };
}
